import { render } from "./App.vue?vue&type=template&id=a9ef5e5e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a9ef5e5e&lang=css"
script.render = render

export default script